window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}

/**
 * DataTable
 */
import DataTable from 'datatables.net-bs5';
window.DataTable = DataTable;
